module.exports = __webpack_public_path__ + "img/S.e755c3e4.svg";